import { useEffect, useState } from "react";
import { filterConstants } from "../../constants";

import {
  IPaymentLink,
  IQueryStringNavLinks,
  ITableHeader,
} from "../../interfaces-and-types";
import { paymentLinksData } from "../../test-data";
import { View } from "./View";

export interface IPaymentLinksViewProps {
  data: IPaymentLink[];
  headers: ITableHeader[];
  isLoading: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  isCreateNewModalOpen: boolean;
  closeModal: () => void;

  // extra buttons
  onExport: () => void;
  onCreateNew: () => void;
}

export const PaymentLinks = () => {
  const [isCreateNewModalOpen, setCreateNewModalOpen] = useState(false);
  const closeModal = () => {
    setCreateNewModalOpen(false);
  };

  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setisLoading(false), 500);
  }, []);

  const headers: ITableHeader[] = [
    {
      key: "linkUrl",
      header: "Link Url",
    },
    {
      key: "status",
      header: "Status",
    },
    {
      key: "product",
      header: "Products/Services",
    },
    {
      key: "price",
      header: "Price",
    },
    {
      key: "date",
      header: "Date Created",
    },
    {
      key: "more",
      header: "",
    },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "Payment Links",
        value: "all",
      },
    ],
  };

  const onExport = () => {
    // export data via api and download
    alert("exporting data...");
  };

  const onCreateNew = () => {
    // openModal
    setCreateNewModalOpen(true);
  };

  return (
    <View
      data={paymentLinksData}
      headers={headers}
      isLoading={isLoading}
      totalCount={paymentLinksData.length}
      queryStringTabs={queryStringTabs}
      onExport={onExport}
      onCreateNew={onCreateNew}
      isCreateNewModalOpen={isCreateNewModalOpen}
      closeModal={closeModal}
    />
  );
};
